module.exports = __webpack_public_path__ + "img/banner.01cdbb63.png";